import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import useActiveBreakpoints from '@/contexts/tailwindContext/hooks/useActiveBreakpoints';
import { Pagination } from '@winelidays/wld-tsx-2/modules';
import { REVIEWS_PER_PAGE } from '../context/reviews.const';
import useReviewsPagination from '../context/useReviewsPagination';
import ReviewList from './ReviewList';
const PaginatedReviews = () => {
    const $ = _c(8);
    const { totalCount, activePageIndex, setActivePageIndex, loadingReviews } = useReviewsPagination();
    const translate = useTranslate();
    const { xs } = useActiveBreakpoints();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = <ReviewList />;
        $[0] = t0;
    }
    else {
        t0 = $[0];
    }
    let t1;
    if ($[1] !== activePageIndex || $[2] !== loadingReviews || $[3] !== setActivePageIndex || $[4] !== totalCount || $[5] !== translate || $[6] !== xs) {
        t1 = <>{t0}
      <Pagination loading={loadingReviews} itemsPerPage={REVIEWS_PER_PAGE} activePageIndex={activePageIndex} setActivePageIndex={setActivePageIndex} totalCount={totalCount} translate={translate} xs={xs} className="mt-9"/></>;
        $[1] = activePageIndex;
        $[2] = loadingReviews;
        $[3] = setActivePageIndex;
        $[4] = totalCount;
        $[5] = translate;
        $[6] = xs;
        $[7] = t1;
    }
    else {
        t1 = $[7];
    }
    return t1;
};
export default PaginatedReviews;
